import React, { ReactNode, useMemo } from 'react';
import { DashboardMediaPopover } from '../DashboardMediaPopover/DashboardMediaPopover';
import useDashboardSelector from '../../../../../redux/selectorHooks/useDashboardSelector';
import { assertNotNil } from '../../../../../utils/types';
import useDashboardAddContent from '../../../utils/useDashboardAddContent';
import {
  ImageEmbedUpload,
  ImageUploady,
} from '../../../../../components/ImageUploady';
import { SingleSelect } from '../../../../../components/Dropdown/SingleSelect';
import { Placement } from '@floating-ui/react';

interface IProps {
  label: ReactNode;
  placement?: Placement;
}

const DashboardAddContent = ({ label, placement }: IProps) => {
  const dashboard = useDashboardSelector('dashboard');
  assertNotNil(dashboard);

  const { popoverProps, imageEmbedUploadProps, createMenuItems } =
    useDashboardAddContent(dashboard, true);

  const menuItems = useMemo(createMenuItems, [createMenuItems]);

  return (
    <>
      <SingleSelect trigger={label} placement={placement}>
        {menuItems}
      </SingleSelect>
      <DashboardMediaPopover {...popoverProps} />
      <ImageUploady>
        <ImageEmbedUpload {...imageEmbedUploadProps} />
      </ImageUploady>
    </>
  );
};

export default DashboardAddContent;
